import React from "react";
import RazorToolTip from "../toolTip/RazorToolTip";

interface myComponentProps {
  icon?: any;
  text?: string;
  onClick?: () => void;
  type?: string;
  active?: boolean;
  activeBgColor?: string;
  activeBgColorTwo?: string;
  className?: string;
  activeTextColor?: string;
  textColor?: string;
  collapse?: boolean;
  activeDirection?: string;
}

const RazorMenuFragment = ({
  active,
  activeBgColor,
  activeBgColorTwo,
  className,
  icon,
  onClick,
  text,
  type,
  activeTextColor,
  textColor,
  collapse,
  activeDirection,
}: myComponentProps) => {
  return (
    <div
      onClick={() => {
        onClick && onClick();
      }}
      className={`menu-fragment-wrapper-index-reusable ${
        active ? "menu-fragment-wrapper-index-reusable-active" : ""
      } ${type === "two" ? "menu-fragment-wrapper-index-reusable-two" : ""} ${
        type === "two" && active
          ? "menu-fragment-wrapper-index-reusable-two-active"
          : ""
      } ${
        activeDirection === "right"
          ? "menu-fragment-wrapper-index-reusable-right"
          : ""
      } 
      
      ${collapse ? "menu-fragment-wrapper-index-reusable-collapse" : ""}
      
      ${className ? className : ""}`}
      style={
        {
          "--active-bg-color": activeBgColor
            ? activeBgColor
            : "rgba(0, 128, 128, 0.1)",
          "--active-bg-two-color": activeBgColorTwo
            ? activeBgColorTwo
            : "rgba(0, 128, 128, 1)",
          "--active-text-color": activeTextColor ? activeTextColor : "#ffffff",
          "--text-color": textColor ? textColor : "#020202",
        } as React.CSSProperties
      }
    >
      {icon && (
        <div className={`icon-box ${collapse ? "tooltip-hover-wrap" : ""}`}>
          <figure className="img-box">{icon}</figure>
          <RazorToolTip text={text} position="right" color="black-light" />
        </div>
      )}
      {text && (
        <p className={`text-menu ${active ? "text-menu-active" : ""}`}>
          {text}
        </p>
      )}
    </div>
  );
};

export default RazorMenuFragment;
